import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

setInterval(() => {
  if (document.getElementById("app") !== null && !document.getElementById("app").hasAttribute("loaded")) {
    new Vue({
      render: h => h(App),
    }).$mount('#app')
  }
}, 100)

